import { render } from "./FieldRead.vue?vue&type=template&id=3c21e3f6&lang=pug"
import script from "./FieldRead.vue?vue&type=script&lang=ts"
export * from "./FieldRead.vue?vue&type=script&lang=ts"
script.render = render

export default script